<div class="el-breadcrumb-wrapper">
    <div class="container">
        <div class="el-breadcrmb-inner">
            <h1>My Plan</h1>
            <ul>

                <li> <a [routerLink]="['/dashboard']" style="color: #e04787;"><i class="fa fa-reply "
                            aria-hidden="true"></i> Back</a></li>
            </ul>
        </div>
    </div>


    <div class="el-pricing-wrapper">
        <div class="container">

            <div class="el-pricing-main-parent">
                <div class="row" style="margin-bottom: 50px;" *ngIf="PurchasePlansList.length>0">
                    <div class="col-md-4">
                        <label>Subject</label>
                        <select class="form-control" [(ngModel)]="Subject" (change)="Subject_Changed()">
                            <option value="All">All</option>
                            <option *ngFor="let _obj of SubjectList" [value]="_obj.SubjectName">{{_obj.SubjectName}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="d-flex justify-content-center" *ngIf="IsShowMessage">
                        <div class="col-md-5 alert">
                            <i class="fa fa-exclamation-triangle" aria-hidden="true"
                                style="font-size: 50px;color: #e04787;"></i>
                            <br><br>

                            <div *ngIf="this.PREP_UserInfo.childId!=null">
                                You have not purchased any plan for <strong>{{this.PREP_UserInfo.childName}}
                                </strong> of <strong *ngIf="PREP_UserInfo.classId <= '12'">Class.
                                    {{PREP_UserInfo.classId}}</strong> <strong
                                    *ngIf="PREP_UserInfo.classId > '12'">Class {{PREP_UserInfo.className}}. </strong>
                                
                                <br><br>
                                <a class="el-btn" [routerLink]="['/product']">Buy Now </a>
                            </div>
                            <div *ngIf="this.PREP_UserInfo.childId==null">
                                No child added yet. Kindly add a child to proceed.
                                <br><br>
                                <a (click)="Switch_Child()" class="el-btn"> <strong>Add Child</strong></a>
                            </div>
                        </div>
                    </div>


                    <div class="col-lg-4 col-md-6" *ngFor="let _obj of PurchasePlansList" style="margin-bottom: 50px;">

                        <div class="el-price-box">
                            <div class="el-price-inner">
                                <!-- <h4 class="el-popular-plan" *ngIf="_obj.Disc_Percentage!=null">{{_obj.Disc_Percentage}} %
                                discount</h4> -->
                                <div class="el-price-head">
                                    <div class="el-price-img d-flex justify-content-between align-items-center">
                                        <h4>{{ _obj.SubjectName }}</h4>


                                        <img [src]="_obj.BookImage" alt="icon" width="100px">

                                    </div>
                                    <p class="el-para">{{ _obj.PlanTitle }}</p>
                                    <!-- <h1>₹ {{ _obj.PlanPrice }}
                                    <span><del *ngIf="_obj.PlanPrice!=_obj.UnitPrice"> ₹ {{ _obj.UnitPrice }} </del>
                                        /Year</span>

                                </h1> -->


                                </div>
                                <div class="el-pricing-list">
                                    <ul>
                                        <li [routerLink]="['/freemock']" class="el-para" style="cursor: pointer;"*ngIf="_obj.PlanType !='Plan 4'"><i
                                                class="fa fa-check-circle"></i>{{_obj.Descriptions}}</li>

                                        <li [routerLink]="['/MyMockTest']" class="el-para" style="cursor: pointer;" *ngIf="_obj.PlanType !='Plan 4'"><i
                                                class="fa fa-check-circle"></i><span>{{_obj.MockCount}}</span> Mock
                                            Tests
                                        </li>
                                        <div *ngIf="_obj.eBooks!=null">
                                            <li *ngFor="let ebook of _obj.eBooks.split('<br>');let i = index"
                                                style="cursor: pointer;">
                                                <i class="fa fa-check-circle"></i> <span (click)="openItem(i,ebook)">
                                                    {{ebook}}</span>
                                            </li>
                                        </div>

                                    </ul>
                                    <!-- <ul *ngFor="let ebook of _obj.eBooks.split('<br>');let i = index">
                                     <li class="el-para"  style="cursor: pointer;">
                                        <i class="fa fa-check-circle"></i> <span (click)="openItem(i,ebook)"> {{ebook}}</span>
                                    </li>
                                </ul> -->
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>